import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { uploadEvent } from '@/api/goods/statistics';
let StatusDialog = class StatusDialog extends Vue {
    constructor() {
        super(...arguments);
        this.withdrawInfo = {
            need_cash_info: {
                apply_list: [],
            },
        };
    }
    async created() {
        let { data } = await this.$axios.get('/api/mobile/account/availableExchangeForCoin', {
            params: {
                amount: +this.exchangePrice,
            },
        });
        this.withdrawInfo = data;
    }
    async cancel() {
        this.addRecord('Click_MyOrder_CancelExchange');
        this.close(false);
    }
    async addRecord(name) {
        uploadEvent.sendRecord(name, '', this.products.reduce((t, c, i) => {
            t.SkuID = t.SkuID += i === 0 ? `${c.id}` : `_${c.id}`;
            t.GoodsName = t.GoodsName += i === 0 ? `${c.title}` : `_${c.title}`;
            return t;
        }, {
            GoodsName: '',
            SkuID: '',
        }), [['p1', 'SkuID']]);
    }
    async toConvert() {
        this.addRecord('Click_MyOrder_ConfirmExchange');
        let memId = sessionStorage.getItem('_sessionStorageDistributorMemId') ||
            sessionStorage.getItem('_cookieDistributorMemId');
        await this.$axios.post('/api/mobile/account/exchangeForCoin', {
            amount: this.exchangePrice,
            distributor_mem_id: memId,
        });
        this.close(true);
    }
};
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "exchangePrice", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "products", void 0);
tslib_1.__decorate([
    Prop()
], StatusDialog.prototype, "close", void 0);
StatusDialog = tslib_1.__decorate([
    Component({})
], StatusDialog);
export default StatusDialog;
